import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { P2PTradingAdminClient } from 'skychain-p2p-trading-js';
import { PaymentMethodEntity } from 'skychain-p2p-trading-js/lib/entities';
import { ExecuteOrderAdminEntity } from 'skychain-p2p-trading-js/lib/entities/execute-order.entity';
import { UserIdentityAdminClient } from 'user-identity-js';
import { UserEntity } from 'user-identity-js/lib/entities';
import { RootState } from '../../../redux/store';
import Body from './Body';
import Title from './Title';
import {
	AdOrderAssetSymbol,
	AdOrderFiatSymbol,
} from 'skychain-p2p-trading-js/lib/dto';

export interface ExecuteDetail extends ExecuteOrderAdminEntity {
	userInfo: UserEntity;
	paymentMethodInfo: PaymentMethodEntity | undefined;
	targetUser: string | undefined;
	assetSymbol: AdOrderAssetSymbol | undefined;
	fiatSymbol: AdOrderFiatSymbol | undefined;
}

export default function BuySellCryptoDetail() {
	const p2pTrading = useSelector((state: RootState) => state.system.p2pTrading);
	const userIdentity = useSelector(
		(state: RootState) => state.system.userIdentity
	);
	const [executeDetail, setExecuteDetail] = useState<ExecuteDetail>();
	const params = useParams();
	const id = params.id;

	useEffect(() => {
		if (p2pTrading && id && userIdentity) {
			getAdDetail(id, p2pTrading, userIdentity);
		}
	}, [p2pTrading, id, userIdentity]);

	const getAdDetail = async (
		id: string,
		p2pTrading: P2PTradingAdminClient,
		userIdentity: UserIdentityAdminClient
	) => {
		if (!p2pTrading) return;
		try {
			const res = await p2pTrading.getExecuteOrderDetail(id);
			const adOrderDetail = await p2pTrading.getAdOrderDetail(
				res.data.adOrderId
			);
			const userInfo = await userIdentity.getUser(res.data.user);

			const paymentMethod = await p2pTrading.getAllPaymentMethod({
				id: adOrderDetail.data.paymentMethod,
			});
			let targetUserInfo: UserEntity | undefined;
			if (res.data.targetUser) {
				targetUserInfo = await userIdentity.getUser(res.data.targetUser);
				console.log('targetUserInfo', targetUserInfo);
			}
			console.log('res', res);
			console.log('adOrderDetail', adOrderDetail);
			setExecuteDetail({
				...res.data,
				userInfo,
				paymentMethodInfo:
					paymentMethod.data.length > 0 ? paymentMethod.data[0] : undefined,
				targetUser: targetUserInfo
					? (targetUserInfo.firstName || '') +
							(targetUserInfo.lastName || '') || targetUserInfo.email
					: '',
				assetSymbol: adOrderDetail.data.assetSymbol,
				fiatSymbol: adOrderDetail.data.fiatSymbol,
			});
		} catch (error) {
			console.log('getAdDetail', error);
		}
	};

	return (
		<div>
			{executeDetail && (
				<>
					<Title executeDetail={executeDetail} />
					<Body executeDetail={executeDetail} />
				</>
			)}
		</div>
	);
}
